import { useEffect, useState } from "react";
import { Button, Col, Modal, Row } from "react-bootstrap";
import { AvField, AvForm } from "availity-reactstrap-validation";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import PhoneInput from "react-phone-input-2";
import UserService from "../../../../services/UserService";
import { Translate } from "../../../Enums/Tranlate";

const AddUserModal = ({ addModal, setAddModal, item, setShouldUpdate }) => {
	const [formData, setFormData] = useState({
		client_name: "",
		phone: "",
	});
	const [isAdd, setIsAdd] = useState(false);
	const [loading, setLoading] = useState(false);
	const lang = useSelector((state) => state.auth.lang);
	const userService = new UserService();

	useEffect(() => {
		if (Object.keys(item)?.length === 0) {
			setIsAdd(true);
		} else {
			setIsAdd(false);
			setFormData({
				id: item?.id,
				client_name: item?.client_name,
				phone: item?.client_phone,
			});
		}
	}, []);

	const submit = (e) => {
		e.preventDefault();
		// if (!formData?.role?.value) {
		// 	return;
		// }
		let data = {
			client_name: formData?.client_name,
			client_phone: formData?.phone,
		};

		setLoading(true);
		if (isAdd) {
			userService
				.create(data)
				?.then((res) => {
					if (res?.status === 201) {
						toast.success(res?.data?.message);
						setShouldUpdate((prev) => !prev);
						setAddModal();
					}
					setLoading(false);
				})
				.catch(() => setLoading(false));
		} else {
			userService
				.update(formData?.id, data)
				?.then((res) => {
					if (res?.status === 200) {
						toast.success(res?.data?.message);
						setShouldUpdate((prev) => !prev);
						setAddModal();
					}
					setLoading(false);
				})
				.catch(() => setLoading(false));
		}
	};

	return (
		<Modal
			className={lang === "en" ? "en fade addAdmin" : "ar fade addAdmin"}
			style={{ textAlign: lang === "en" ? "left" : "right" }}
			show={addModal}
			onHide={() => {
				setAddModal();
			}}>
			<AvForm className="form-horizontal" onValidSubmit={submit}>
				<Modal.Body>
					<Row>
						<Col md={12} className="mb-2">
							<div className="d-flex justify-content-between">
								<p
									className="mb-0 text-black fw-bold"
									style={{
										fontSize: "20px",
									}}>
									{isAdd ? Translate[lang]?.add : Translate[lang]?.edit}{" "}
									{Translate[lang]?.user}
								</p>
								<Button
									variant=""
									className="close"
									style={{
										right: lang === "en" ? "0" : "auto",
										left: lang === "ar" ? "0" : "auto",
									}}
									onClick={() => {
										setAddModal();
									}}>
									<span style={{ fontSize: "22px" }}>&times;</span>
								</Button>
							</div>
						</Col>

						{/* Name */}
						<Col md={12}>
							<label className="text-label">
								{Translate[lang]?.client_name}
							</label>
							<AvField
								type="text"
								placeholder={Translate[lang]?.name}
								bsSize="lg"
								name="client_name"
								validate={{
									required: {
										value: true,
										errorMessage: Translate[lang].field_required,
									},
								}}
								value={formData.client_name}
								onChange={(e) =>
									setFormData({
										...formData,
										client_name: e.target.value,
									})
								}
							/>
						</Col>
						{/* Phone */}
						<Col md={12} className="mb-3">
							<label>{Translate[lang]?.phone}</label>
							<PhoneInput
								country={"kw"}
								enableSearch={true}
								value={formData?.phone}
								onChange={(e) => setFormData({ ...formData, phone: e })}
							/>
						</Col>
					</Row>
				</Modal.Body>
				<Modal.Footer>
					<Button
						variant="primary"
						type="submit"
						className="w-100"
						disabled={loading}>
						{isAdd ? Translate[lang]?.add : Translate[lang]?.edit}{" "}
						{Translate[lang]?.user}
					</Button>
				</Modal.Footer>
			</AvForm>
		</Modal>
	);
};

export default AddUserModal;
